module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-new order-right-summary right-info-block",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "order-instruction-header"
  }, [_c('i', {
    staticClass: "ion-information-circled header-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("Pomoc")])]), _vm._v(" "), _c('img', {
    staticClass: "right-order-block-img",
    attrs: {
      "src": "https://www.mojadostawa.pl/lib/customerZone/images/ind-main-02.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "simple-paragraph"
  }, [_c('p', [_vm._v("Jeżeli chciałbyś dokonać ewentualnej zmiany w swoim zamówieniu lub chciałbyś uzyskać więcej informacji o realizowanym zleceniu, skontaktuj sie z nami.")]), _vm._v(" "), _c('p', [_vm._v("Nasi konsultanci są do Twojej stałej dyspozycji pod nr tel.: "), _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("(22) 307 68 98")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f1b0bcc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpBox.vue
// module id = 252
// module chunks = 1